import Container from 'typedi'
import {VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import AuthService from '../services/auth.service'
import GtrStorage from '../services/storage.service'
import UserSession from '@/modules/common/models/user-session.model'
import { ParticipantCourseProgress, UpdateParticipantContentProgressPayload } from '@/modules/learning/learning.model'

@Module({
    namespaced: true
})
export default class AuthStore extends VuexModule {
    event: any = {}
    userSession: UserSession | undefined = undefined
    viewable_reg_pages: any[] = []
    current_reg_pages: any[] = []
    participant: any = {}
    needAuthField =  false
    requireInvite = false

    get getUserSession (): any {
        return this.userSession
    }

    get participantCourseProgress (): ParticipantCourseProgress {
        return this.participant?.participant_data?.course_progress || {}
    }

    @Mutation
    SET_EVENT (payload: any) {
        this.event = payload
    }

    @Mutation
    SET_PARTICIPANT (payload: any) {
        this.participant = payload
    }

    @Mutation
    SET_USER_SESSION (payload: { event_identifier: string; securityContext: UserSession | undefined }) {
        const { event_identifier, securityContext } = payload
        this.userSession = securityContext
        if (securityContext) {
            Container.get(GtrStorage).setItem(`${event_identifier}_registration_access_token`, securityContext.access_token)
            Container.get(GtrStorage).setItem(
              'user_session',
              JSON.stringify({
                  access_token: securityContext.access_token,
                  expires_at: securityContext.expires_at,
                  expires_in: securityContext.expires_in
              })
            )
        }
    }

    @Mutation
    SET_VIEWABLE_REG_PAGES (payload: any) {
        this.viewable_reg_pages = payload
    }

    @Mutation
    SET_CURRENT_REG_PAGES (payload: any) {
        this.current_reg_pages = payload
    }

    @Mutation
    SET_NEED_AUTH_FIELD (payload: any) {
        this.needAuthField = payload
    }

    @Mutation
    SET_REQUIRE_INVITE (payload: any) {
        this.requireInvite = payload
    }

    @Action({ rawError: true })
    async updatePassword (payload: any) {
        const { event_identifier,isDev, password_token, data } = payload // eslint-disable-line @typescript-eslint/no-unused-vars
        const response = await Container.get(AuthService).updatePassword(event_identifier, password_token, data)
        // router.push('/' + (isDev ? 'dev/' : '') + event_identifier)
        return response
    }

    @Action({ rawError: true })
    async emailResetPassword (payload: any) {
        const { event_identifier, data } = payload
        const response = await Container.get(AuthService).emailResetPassword(event_identifier, data)
        return response
    }

    @Action({ rawError: true })
    async emailLoginDetails (payload: any) {
        const { event_identifier, data } = payload
        const response = await Container.get(AuthService).emailLoginDetails(event_identifier, data)
        return response
    }

    @Action({ rawError: true })
    async login (payload: any) {
        const { event_identifier, form, data } = payload // eslint-disable-line @typescript-eslint/no-unused-vars
        const query_params: any = []
        const registration_type_query_param = data.registrationTypeData ? `registration_type=${data.registrationTypeData.option_uuid}` : ''
        if (registration_type_query_param) {
            query_params.push(registration_type_query_param)
        }
        if (form) {
            query_params.push('form=' + form)
        }
        const query_string = query_params.length ? '?' + query_params.join('&') : ''
        const response = await Container.get(AuthService).login(event_identifier, query_string, data)
        this.context.commit('SET_USER_SESSION', { event_identifier, securityContext: response.data })
        return response
    }

    @Action({ rawError: true })
    async refreshToken (payload: any) {
        const { event_identifier, form } = payload
        const response: any = await Container.get(AuthService).refreshToken(event_identifier, form)
        this.context.commit('SET_USER_SESSION', { event_identifier, securityContext: response.data })
        return response.data
    }

    @Action({ rawError: true })
    async registration(payload: any) {
        const { event_identifier, form, data } = payload
        const query_params: any = []
        const registration_type_query_param = data.registrationTypeData ? `registration_type=${data.registrationTypeData.option_uuid}` : ''
        if (registration_type_query_param) {
            query_params.push(registration_type_query_param)
        }
        if (form) {
            query_params.push('form=' + form)
        }
        const query_string = query_params.length ? '?' + query_params.join('&') : ''
        const response = await Container.get(AuthService).registration(event_identifier, query_string, data)
        return response
    }

    @Action({ rawError: true })
    async requestInvite (payload: any) {
        const  { event_identifier, data } = payload
        const response = await Container.get(AuthService).requestInvite(event_identifier, data)
        return response
    }

    @Action({ rawError: true })
    async getSession (payload: any) {
        const { event_identifier,data } = payload
        const response = await Container.get(AuthService).getSession(event_identifier, data)
        return response
    }

    @Action({ rawError: true })
    async getParticipant (payload: any) {
        const { event_identifier } = payload
        const response = await Container.get(AuthService).getParticipant(event_identifier)
        this.context.commit('SET_PARTICIPANT', response.data)
        return response
    }

    @Action({ rawError: true })
    async updateParticipantLessonProgress (payload: UpdateParticipantContentProgressPayload) {
        const { course_uuid, content_id, content_progress } = payload
        const response = await Container.get(AuthService).updateParticipantLessonProgress(course_uuid, content_id, content_progress)
        this.context.dispatch('getParticipant', { event_identifier: course_uuid })
        return response
    }
}
